import { GoogleAnalytics4 } from '@backstage-community/plugin-analytics-module-ga4';
import { NoOpAnalyticsApi } from '@backstage/core-compat-api';
import {
  analyticsApiRef,
  ApiBlueprint,
  configApiRef,
  identityApiRef,
} from '@backstage/frontend-plugin-api';

export const AnalyticsApi = ApiBlueprint.make({
  name: 'analytics',
  params: defineParams =>
    defineParams({
      api: analyticsApiRef,
      deps: { configApi: configApiRef, identityApi: identityApiRef },
      factory: ({ configApi, identityApi }) => {
        try {
          return GoogleAnalytics4.fromConfig(configApi, { identityApi });
        } catch {
          return new NoOpAnalyticsApi();
        }
      },
    }),
});
